import { logger } from '@/lib/client'
import { TrackingProductRecommendationSchema } from '@/schemas/tracking.product'
import type { z } from 'zod'
import ga4 from './analytics/ga4'

export const RecommendationImpression = async (
  properties: z.infer<typeof TrackingProductRecommendationSchema>,
): Promise<void> => {
  const event = 'Visualizou o produto recomendado'

  try {
    if (TrackingProductRecommendationSchema.parse(properties)) {
      ga4.viewRecommendation(properties)
    }
  } catch (error) {
    logger(
      'TRACKING RECOMMENDATION IMPRESSION',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}

export const RecommendationClick = async (
  properties: z.infer<typeof TrackingProductRecommendationSchema>,
): Promise<void> => {
  const event = 'Clicou no produto recomendado'

  try {
    if (TrackingProductRecommendationSchema.parse(properties)) {
      ga4.clickRecommendation(properties)
    }
  } catch (error) {
    logger(
      'TRACKING RECOMMENDATION CLICK',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}
